"use strict"
import { gsap } from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

//LA DATE//
let year = new Date().getFullYear();
let date = document.querySelector("#date");
date.innerHTML = "©rafko2022-" + String(year + 1);

//DARKMODE//
let darkmodeButtonEl = document.querySelector(".btn--darkmode")
let activeTheme = localStorage.getItem("theme");
if (activeTheme) {
	setTheme(activeTheme);
	if (activeTheme == "dark") {
		darkmodeButtonEl.innerHTML = "Light Mode";
	}
	if (activeTheme == "light") {
		darkmodeButtonEl.innerHTML = "Dark Mode";
	}
}
if (darkmodeButtonEl) {
	darkmodeButtonEl.addEventListener("click", toggleTheme);
}

function toggleTheme() {
	let theme = document.body.getAttribute("data-theme");
	if (theme == "dark") {
		document.body.setAttribute('data-theme', theme);
		setTheme("light");
		darkmodeButtonEl.innerHTML = "Dark Mode";
	} else {
		setTheme("dark")
		darkmodeButtonEl.innerHTML = "Light Mode";
	}
}

function setTheme(theme) {
	document.body.setAttribute('data-theme', theme);
	localStorage.setItem("theme", theme);
}

//BURGER MENU//

const navSlide = () => {
	const burger = document.querySelector('.burger');
	const nav = document.querySelector('.nav-links');
	const navLinks = document.querySelectorAll('.nav-links li');


	burger.addEventListener('click', () => {

		nav.classList.toggle('nav-active');

		navLinks.forEach((link, index)=>{
			if (link.style.animation) {
				link.style.animation = '';
	
			}else {
				link.style.animation = `navLinkFade 0.5s ease forwards ${index / 5 + 0.5}s`;
			}
		});
		burger.classList.toggle('toggle');
	});
}
navSlide();

//GSAP//
var font = document.querySelector('.plx-txt--1');
if(font){
	gsap.to(".plx-txt--1", {
		x:-50,
		duration:0.1,
		scrollTrigger: {
			trigger: ".plx-txt--1",
			scrub: true,
		},
	})
};

var font = document.querySelector('.plx-txt--2');
if(font){
	gsap.to(".plx-txt--2", {
		x:50,
		duration:0.1,
		scrollTrigger: {
			trigger: ".plx-txt--2",
			scrub: 0.5,
		},
	})
};

var font = document.querySelector('.plx-txt--3');
if(font){
	gsap.to(".plx-txt--3", {
		x:50,
		duration:0.1,
		scrollTrigger: {
			trigger: ".plx-txt--3",
			scrub: true,
		},
	})
};

//animation index//
var hoverMouse = function($el) {
	$el.each(function() {
	  var $self = $(this);
	  var hover = false;
	  var offsetHoverMax = $self.attr("offset-hover-max") || 0.7;
	  var offsetHoverMin = $self.attr("offset-hover-min") || 0.5;
  
	  var attachEventsListener = function() {
		$(window).on("mousemove", function(e) {
		  //
		  var hoverArea = hover ? offsetHoverMax : offsetHoverMin;
  
		  // cursor
		  var cursor = {
			x: e.clientX,
			y: e.clientY - $(window).scrollTop()
		  };
  
		  // size
		  var width = $self.outerWidth();
		  var height = $self.outerHeight();
  
		  // position
		  var offset = $self.offset();
		  var elPos = {
			x: offset.left + width / 2,
			y: offset.top + height / 2
		  };
  
		  // comparaison
		  var x = cursor.x - elPos.x;
		  var y = cursor.y - elPos.y;
  
		  // dist
		  var dist = Math.sqrt(x * x + y * y);
  
		  // mutex hover
		  var mutHover = false;
  
		  // anim
		  if (dist < width * hoverArea) {
			mutHover = true;
			if (!hover) {
			  hover = true;
			}
			onHover(x, y);
		  }
  
		  // reset
		  if (!mutHover && hover) {
			onLeave();
			hover = false;
		  }
		});
	  };
  
	  var onHover = function(x, y) {
		TweenMax.to($self, 0.4, {
		  x: x * 0.8,
		  y: y * 0.8,
		  //scale: .9,
		  rotation: x * 0.05,
		  ease: Power2.easeOut
		});
	  };
	  var onLeave = function() {
		TweenMax.to($self, 0.7, {
		  x: 0,
		  y: 0,
		  scale: 1,
		  rotation: 0,
		  ease: Elastic.easeOut.config(1.2, 0.4)
		});
	  };
  
	  attachEventsListener();
	});
  };
  
  hoverMouse($('.welcome-img'));

